import { useCallback, useEffect, useMemo, useState } from 'react'

export const useGetComparisonFormLocal = () => {
  const [comparisonList, setComparisonList] = useState(
    localStorage.getItem('productComparison'),
  )

  // Listen for storage changes to keep the hook reactive
  useEffect(() => {
    const handleStorageChange = () => {
      setComparisonList(localStorage.getItem('productComparison'))
    }

    // Listen for storage events (from other tabs/windows)
    globalThis.addEventListener('storage', handleStorageChange)

    // Listen for custom event for same-tab changes
    globalThis.addEventListener('productComparisonUpdated', handleStorageChange)

    return () => {
      globalThis.removeEventListener('storage', handleStorageChange)
      globalThis.removeEventListener(
        'productComparisonUpdated',
        handleStorageChange,
      )
    }
  }, [])

  const listProduct = useMemo(() => {
    try {
      return JSON.parse(comparisonList)
    } catch {
      return []
    }
  }, [comparisonList])

  const listProductIds = useMemo(() => {
    return (listProduct ?? []).map(({ materialNumber }) => materialNumber)
  }, [listProduct])

  const deleteProductIds = useCallback(
    (productId) => {
      const newList = listProduct.filter(
        ({ materialNumber }) => materialNumber !== productId,
      )

      localStorage.setItem('productComparison', JSON.stringify(newList))
      // Dispatch custom event to notify other components
      globalThis.dispatchEvent(new CustomEvent('productComparisonUpdated'))
    },
    [listProduct],
  )

  const getListPriceFromLocal = useCallback(
    (materialNumber) => {
      if (Array.isArray(listProduct)) {
        return (
          listProduct.find(
            (product) => product.materialNumber === materialNumber,
          )?.listPrice || 0
        )
      }
      return 0
    },
    [listProduct],
  )

  return {
    listProductIds,
    deleteProductIds,
    getListPriceFromLocal,
  }
}
